import { SMARTBRIEF_ROOT } from "../constants";

export type LinkItem = {
    label: string;
    href: string;
};

export type MenuItems = LinkItem[];

export const AdvertiseItems: MenuItems = [
    {
        label: "Advertise",
        href: `${SMARTBRIEF_ROOT}/advertise`,
    },
    {
        label: "Media Kits",
        href: `${SMARTBRIEF_ROOT}/media-kits`,
    },
    {
        label: "Marketing insights",
        href: `${SMARTBRIEF_ROOT}/resources`,
    },
];

export const SubscriptionsItem: LinkItem = {
    label: "Subscriptions",
    href: `${SMARTBRIEF_ROOT}/subscriptions`,
};

export const PartnerItem: LinkItem = {
    label: "Partner",
    href: `${SMARTBRIEF_ROOT}/partner`,
};

export const ArticlesItem: LinkItem = {
    label: "Articles",
    href: `${SMARTBRIEF_ROOT}/articles`,
};

export const SmartStudioItem: LinkItem = {
    label: "SmartStudio",
    href: `${SMARTBRIEF_ROOT}/smartstudio`,
};
